import { ConfigInterface } from 'swr';
import { parseUrl, useWPAcfV3Api, wpAcfV3Api } from '@gik/core/api';
import { IWordpressFeatureVideo } from '@gik/core/models/wordpress/WordpressFeatureVideo';

const path = 'options/options/feature_videos';

export interface IFeatureVideosResponse {
  feature_videos: IWordpressFeatureVideo[];
}

export function getFeatureVideos() {
  const finalUrl = parseUrl(path, {});
  return wpAcfV3Api.get(finalUrl);
}

export function useFeatureVideos(config?: ConfigInterface) {
  return useWPAcfV3Api<IFeatureVideosResponse>(path, config, {});
}
